/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContactCopyright } from '../../models/contact-copyright';
import { NewContactCopyright } from '../../models/new-contact-copyright';

export interface CreateCopyright$Params {
      body?: NewContactCopyright
}

export function createCopyright(http: HttpClient, rootUrl: string, params?: CreateCopyright$Params, context?: HttpContext): Observable<StrictHttpResponse<ContactCopyright>> {
  const rb = new RequestBuilder(rootUrl, createCopyright.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ContactCopyright>;
    })
  );
}

createCopyright.PATH = '/editor/contact-copyrights';
